export interface EntraRuntimeConfig {
  disabled: boolean;
}

export function resolveEntraConfig(): EntraRuntimeConfig {
  const mode = import.meta.env.VITE_ENTRA_AUTH_MODE;
  return {
    disabled: mode === 'dev' || (!import.meta.env.PROD && !mode),
  };
}
